import { render } from "./Rate.vue?vue&type=template&id=50e26d90&scoped=true"
import script from "./Rate.vue?vue&type=script&lang=js"
export * from "./Rate.vue?vue&type=script&lang=js"

import "./Rate.vue?vue&type=style&index=0&id=50e26d90&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e26d90"]])

export default __exports__